module.exports = __webpack_public_path__ + "static/img/tsl_2017.04a6008.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tsl_2017.png
// module id = 383
// module chunks = 1